import { menuItems } from "./menuItems";

function isMenuItemPathEnabled(path, content) {
  if (!path) return true;
  const lower = path.toLowerCase();
  if (lower.startsWith("/blog")) {
    return content.isBlogPageEnabled !== false;
  }
  if (lower.startsWith("/counseling")) {
    return content.isConsultationPageEnabled !== false;
  }
  if (lower.startsWith("/reservation")) {
    return content.isReservationPageEnabled !== false;
  }
  return true;
}

/**
 * Filters dropdown / offcanvas menu entries when tenant feature flags are off.
 * Preserves dividers only when they sit between visible items.
 */
export function filterMenuItemsByTenantFeatures(items, content) {
  if (!content) return items;

  const kept = items.filter((item) => {
    if (item.type === "divider") return true;
    return isMenuItemPathEnabled(item.path, content);
  });

  const out = [];
  for (let i = 0; i < kept.length; i++) {
    const item = kept[i];
    if (item.type !== "divider") {
      out.push(item);
      continue;
    }
    if (out.length === 0) continue;
    if (out[out.length - 1].type === "divider") continue;
    let hasFollowingItem = false;
    for (let j = i + 1; j < kept.length; j++) {
      if (kept[j].type !== "divider") {
        hasFollowingItem = true;
        break;
      }
    }
    if (hasFollowingItem) out.push(item);
  }
  while (out.length > 0 && out[out.length - 1].type === "divider") {
    out.pop();
  }
  return out;
}

export function getTenantFilteredMenuItems(content) {
  return filterMenuItemsByTenantFeatures(menuItems, content);
}
